import { jsx as _jsx } from "react/jsx-runtime";
import './KodanshaSubmit.scss';
var KodanshaSubmit = function (_a) {
    var _b = _a.text, text = _b === void 0 ? '' : _b, _c = _a.styles, styles = _c === void 0 ? '' : _c, onSubmitClicked = _a.onSubmitClicked;
    var onButtonClicked = function (e) {
        e.preventDefault();
        e.stopPropagation();
        onSubmitClicked();
    };
    return (_jsx("button", { onClick: onButtonClicked, className: "submit ".concat(styles), children: text }));
};
export default KodanshaSubmit;
